export default __webpack_public_path__ + "static/media/gh_logo.6474bb54.svg";